import { useEffect, useRef } from 'react';
import { saveSession } from '../utils/storage.js';

export const useAutoSave = (state) => {
  const timer = useRef(null);
  useEffect(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => saveSession(state), 300);
    return () => clearTimeout(timer.current);
  }, [state]);
};